export const SITE_NAME = 'Gula Väggen';
export const TITLE_SEPARATOR = ' | ';
export const DEFAULT_TITLE = 'Gula Väggen – Sveriges landslag, supporterkultur & evenemang';
export const DEFAULT_DESCRIPTION = 'Gula Väggen är Sveriges officiella samlingsplats för landslagsupplevelser, evenemang och inkluderande supporterkultur. Delta i matcher, träffa fans och upplev gemenskap!';
export const DEFAULT_KEYWORDS = 'Svenska landslaget, landslaget, landslag, fotboll, hockey, handboll';
export const DEFAULT_IMAGE = '/Supporterforeningen.png';
export const DEFAULT_LOCALE = 'sv_SE';
export const SITE_LANG = 'sv';
export const BASE_URL = process.env.REACT_APP_SITE_URL; // e.g. https://www.gulavaggen.nu
